import React from "react";

import {createTheme, ThemeProvider} from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import {TooltipDetailsPromoPopup} from "./TooltipDetailsPromoPopup/TooltipDetailsPromoPopup";
import {FlyerPageSpotDto, PromoDto} from "../../../dtos";
import {ReactComponent as ApprovePromotion} from "../../../assets/promos&items/approved_promo.svg";
import {ReactComponent as NotApprovePromotion} from "../../../assets/promos&items/not_approved_promo.svg";
import {ReactComponent as ApprovePromotionForSystem} from "../../../assets/promos&items/approved_promo_system.svg";


const theme = createTheme({
    components: {
        // Name of the component
        MuiTooltip: {
            styleOverrides: {
                // Name of the slot
                tooltip: {
                    // Some CSS
                    backgroundColor: '#ffffff',
                    color: '#000000',
                    width: '320px',
                    maxWidth: `initial`,
                    // maxHeight: '360px',
                    border: '1px solid #4D4D4D',
                    borderRadius: '5px',

                },
            },
        },
    },
});

interface Props {
    promo: PromoDto;
    caption: string;
    editPromotion: (e: React.MouseEvent<HTMLElement>) => void;
    promoQualification: number | undefined;
    isShowPromoCaption: boolean;
    frame?: FlyerPageSpotDto;
}


export const QualificationForPromoComponent: React.FC<Props> = (
    {
        promo,
        caption,
        editPromotion,
        promoQualification,
        isShowPromoCaption,
        frame
    }
) => {

    let QualificationIcon;
    switch (promoQualification){
        case 1:
            QualificationIcon = ApprovePromotionForSystem;
            break
        case 2:
            QualificationIcon = ApprovePromotion;
            break
        default:
            QualificationIcon = NotApprovePromotion;
            break;
    }

    return (
        <>
            <ThemeProvider theme={theme}>
                <Tooltip
                    enterDelay={500}
                    enterNextDelay={500}
                    title={<TooltipDetailsPromoPopup
                        promo={promo}
                        promotionTypeCaption={caption}
                        editPromotion={editPromotion}
                        isShowPromoCaption={isShowPromoCaption}
                        frame={frame}
                    />}
                    placement={"right-start"}
                >
                    <QualificationIcon />
                </Tooltip>
            </ThemeProvider>
        </>
    )
}